import __request__ from "routing/request";
export function sidecars(sort = "node_name", page = 1, per_page = 50, query, order = "asc", only_active = false) {
  return __request__("GET", "/sidecars", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order, "only_active": only_active }, {
    "Accept": ["application/json"]
  });
}
export function all() {
  return __request__("GET", "/sidecars/all", null, {}, {
    "Accept": ["application/json"]
  });
}
export function assignConfiguration(JSONbody) {
  return __request__("PUT", "/sidecars/configurations", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getBasicSidecarUser() {
  return __request__("GET", "/sidecars/user", null, {}, {
    "Accept": ["application/json"]
  });
}
export function get(sidecarId) {
  return __request__("GET", `/sidecars/${sidecarId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function register(sidecarId, JSONbody) {
  return __request__("PUT", `/sidecars/${sidecarId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
